import React, { Component } from 'react';
import { connect } from 'react-redux';
import CanDisplay from '../../CanDisplay';
import './EditUserSubMenu.scss';

class EditUserSubMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayModal: false,
    };
  }

  render() {
    const remainder = this.props.userData.index % this.props.tablePageSize;
    return (
      <div>
        <div
          className="editUserSubMenu"
          style={{
            top:
              this.props.tablePage === 0 &&
              this.props.userData.index < this.props.tablePageSize
                ? `calc(70px + 37px* ${this.props.userData.index})`
                : `calc(70px + 37px* ${remainder})`,
          }}
        >
          <CanDisplay
            rules={this.props.rules}
            perform="edit_users"
            yes={() => (
              <button
                id="editUserBtn"
                onClick={() => {
                  this.props.openEditAccountModal();
                }}
              >
                Edit User
              </button>
            )}
          />
          <button
            id="deleteUserBtn"
            onClick={() => {
              this.props.openDeleteAccountModal();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, rules }) => {
  return {
    auth,
    rules,
  };
};

export default connect(mapStateToProps, {})(EditUserSubMenu);
